// SPDX-License-Identifier: MIT
// Frontend entry to the Mollie checkout. Calls the `checkout` Edge Function with a
// SKU (the server decides the price + what it grants — the client never sends an
// amount) and redirects the browser to Mollie's hosted checkout. The function
// requires a signed-in user; a 401 surfaces as `need_auth` so the caller can ask
// the visitor to sign in first. `nav` is injectable for tests.
import { supabase } from '../auth/supabase';

export type CheckoutOutcome =
  | { ok: true }
  | { ok: false; reason: 'need_auth' | 'error' };

interface CheckoutResponse { checkout_url?: string; payment_id?: string; error?: string }

export async function startCheckout(
  sku: string,
  nav: (url: string) => void = (url) => { window.location.href = url; },
): Promise<CheckoutOutcome> {
  const { data, error } = await supabase.functions.invoke<CheckoutResponse>('checkout', {
    body: { sku },
  });
  if (error) {
    // supabase-js wraps non-2xx in FunctionsHttpError; status is on .context (a Response).
    const status = (error as { context?: Response }).context?.status;
    return { ok: false, reason: status === 401 ? 'need_auth' : 'error' };
  }
  if (!data?.checkout_url) return { ok: false, reason: 'error' };
  nav(data.checkout_url);
  return { ok: true };
}
